import React, { useState, useEffect, useMemo } from "react";
import styles from "../../css/navbar.module.css";
import icons from "../../css/icons.module.css";

const Navbar = () => {


  return (
      <nav>
        <div className={styles.containerContact}>
        
        </div>
        <div className={styles.navbar}>
          <div className={styles.navbarFlex}>
            <div className={icons.logoAlight}></div>
      



<div className={styles.containerCenter}>

  
        
<a href="
https://docs.google.com/document/d/1ppj0l7ApnIea8koIHmQpjbbPCFmD962b/edit?usp=sharing&ouid=110809832823782368723&rtpof=true&sd=true

">
<button className={styles.btnCv} > Visita mi CV </button>
</a>






</div>





       
      
        </div>     <div className={styles.line}></div>       </div>
   
      </nav>
    );
  };

export default Navbar;
